import { createSlice } from '@reduxjs/toolkit'
import { getContract, getContractByCaseId } from '../contract/thunks';
import {getWorkshopSearch} from "./thunks"

const initialState= { 
  list: null, 
  loading: "idle",
  error: null }

const workshopSearchSlice = createSlice({
  name: 'workshopSearch',
  initialState,
  reducers: {
    setWorkshopSearchFilters:(state, action)=>{
      state.filters= action.payload
    }
  },
  extraReducers: {
    [getWorkshopSearch.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getWorkshopSearch.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.list = action.payload
      
    },
    [getWorkshopSearch.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getContract.fulfilled]:(state)=>initialState,
    [getContractByCaseId.fulfilled]:(state)=>initialState
  }
})

export const {setWorkshopSearchFilters} = workshopSearchSlice.actions
export default workshopSearchSlice.reducer
